import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '../shared/shared.module';
import { InvoiceDataBuilder } from './invoice-data.builder';
import { InvoiceDataService } from './invoice-data.service';
import { InvoiceDataEffects } from './invoice-data.effects';
import { FEATURE_NAME, reducer } from './invoice-data.reducer';
import { InvoiceDataDispatcher } from './invoice-data.dispatcher';
import { InvoiceDataStore } from './invoice-data.store';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    EffectsModule.forFeature([InvoiceDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
})
export class InvoiceDataModule {
  static forRoot(): ModuleWithProviders<InvoiceDataModule> {
    return {
      ngModule: InvoiceDataModule,
      providers: [
        InvoiceDataBuilder,
        InvoiceDataService,
        InvoiceDataDispatcher,
        InvoiceDataStore,
      ],
    };
  }
}
